import { ProfileGender } from '../../../enums/profile/profile-gender';
import { BloodType } from '../../../enums/social-network/clinical-case/clinical-case-bloodtype';
import { FitzpatrickScale } from '../../../enums/social-network/clinical-case/clinical-case-fitzpatrick-type';

export class ClinicalCasePatientInformation {
  public age?: number;
  public gender?: ProfileGender;
  public fitzPatrick?: FitzpatrickScale;
  public weight?: number;
  public height?: number;
  public bloodType?: BloodType;
  public medicalHistory?: string;
  public medications?: string;
  public otherHistory?: string;
  public allergies?: string;
}
